export const NeedLoginStatus = [
  '110001', // 未经过身份认证
  '110002', //非法凭证
  '110004', //非法令牌
  '110005', //令牌过期
  '110011', //用户离职
  '110012', //该账号被禁用
  '110013', //该账号被踢出
  '110034', //未激活 未启用
  '110028', //系统升级中
]
